/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ level: NonNullable<unknown> }} Leveling_Ladder_LevelInputs */



/**
* | output |
* | --- |
* | "Level {level}" |
*
* @param {Leveling_Ladder_LevelInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const leveling_ladder_level = /** @type {((inputs: Leveling_Ladder_LevelInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Leveling_Ladder_LevelInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Уровень ${i?.level}`)
	return /** @type {LocalizedString} */ (`Level ${i?.level}`)
});